const DayleSchedule = () => import(/* webpackChunkName: "dayleSchedule" */ './DayleSchedule.vue')
const WeekTask = () => import(/* webpackChunkName: "weekTask" */ './WeekTask.vue')

const index = {
  path: 'schedule',
  name: 'Dayle Schedule',
  component: DayleSchedule,
  props: true,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

const week = {
  path: 'schedule/week',
  name: 'Week Task',
  component: WeekTask,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

export default {
  index,
  week
}
